import { useMutation } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { LinkSquare02Icon } from "@hugeicons-pro/core-stroke-rounded";
import { Button, ButtonSize, ButtonVariant } from "shared/components";
import { boomFinanceApi } from "api/boom-finance";
import { getErrorMessage } from "utils/error";

interface Props {
  boomFinanceExternalId?: string | null;
}

export const BoomFinanceLinkButton = ({ boomFinanceExternalId }: Props) => {
  const { mutate: openInLenderPortal, isPending } = useMutation({
    mutationKey: ["BOOM_FINANCE_MAGIC_LINK", "CREATE"],
    mutationFn: () =>
      boomFinanceApi.createMagicLink({
        redirectTo: `/applications/${boomFinanceExternalId}`
      }),
    onSuccess: ({ url }) => {
      window.open(url, "_blank", "noopener,noreferrer");
    },
    onError: (err) => {
      toast.error(getErrorMessage(err));
    }
  });

  return (
    <Button
      borderLess
      variant={ButtonVariant.BASE}
      size={ButtonSize.SM}
      HugeIcon={LinkSquare02Icon}
      iconPosition="left"
      onClick={() => openInLenderPortal()}
      disabled={isPending}
      loading={isPending}
      className="!text-content-400 !stroke-content-400"
    >
      Open in BoomFinance
    </Button>
  );
};
